<template>
  <div class="register-login__options-container">
    <div class="register-login__subheader">
      <p class="register-login__subtitle ds1-utd-weight-bold">
        A new UpToDate account is being created for you.
      </p>
      <p>
        Please select carefully from the 2 choices below for this account:
      </p>
    </div>
    <div class="register-login__card-container">
      <UtdOptionsCard class="register-card primary-card">
        <template #content>
          <div class="register-login__options-list">
            <p>Select <span class="ds1-utd-weight-bold">"Register"</span> 
              if one of these options applies:</p>
            <ul class="register-login__register-list">
              <li>If you do not already have an UpToDate account</li>
              <li>If you have a pre-existing UpToDate account and want to keep 
                your new account separate
              </li>
            </ul>
          </div>
        </template>
        <template #actions>
          <UtdButton id="registerButton"
                     button-size="large"
                     button-style="ghost"
                     @click="$emit('on-register-click')">
            Register
          </UtdButton>
        </template>
      </UtdOptionsCard>
      <UtdOptionsDivider class="register-login__divider">
        <template #text>OR</template>
      </UtdOptionsDivider>
      <UtdOptionsCard class="merge-card primary-card">
        <template #title>
          <h2 class="register-login__card-title ds1-utd-h4">
            Merge your new account with an existing account
          </h2>
        </template>
        <template #content>
          <div class="register-login__options-list">
            <p>Select <span class="ds1-utd-weight-bold">"Merge accounts"</span> 
              if you have a pre-existing account and want to combine your new account 
              with it to keep your CME credits in one account, if applicable.
            </p>
          </div>
        </template>
        <template #actions>
          <UtdButton id="mergeButton"
                     button-size="large"
                     button-style="ghost"
                     @click="handleMergeAccounts">
            Merge Accounts
          </UtdButton>
        </template>
      </UtdOptionsCard>
    </div>
  </div>
</template>

<script setup>
import UtdOptionsCard from '_acaSrc/components/shared/stdlib/UtdOptionsCard.vue';
import UtdButton from '_acaSrc/components/shared/stdlib/UtdButton.vue';
import UtdOptionsDivider from '_acaSrc/components/shared/stdlib/UtdOptionsDivider.vue';

const emit = defineEmits([ 'on-register-click', 'on-merge-click' ]);

const handleMergeAccounts = () => {
    emit('on-merge-click');
};
</script>

<style lang="less" scoped>
@import (reference) '~_acaAssets/wkce/colors/wkce-app-styles';

@media only screen and (min-width: 768px) {
  .register-login__options-list {
    .ds1-ml-2();
    .ds1-mr-3();
  }
}

.register-login__options-container {  
  p {
    .ds1-reset-p();
    .ds1-mb-1();
  }
}

.register-login__divider {
  .ds1-mv-5();
  .ds1-utd-h1();
  color: @DS1-UTD-OPTIONS-CARD-TITLE-COLOR;
}

.register-login__subheader {
  .ds1-mt-1();
  .ds1-mb-3();
}

.register-login__card-container {
  .ds1-flex-vertical-center();
  flex-direction: column;
  justify-content: center;
}
  
.register-login__card-title {
  .ds1-ma-0();
  .ds1-mb-1();
  color: @DS1-UTD-OPTIONS-CARD-TITLE-COLOR;
  flex: 1;
}

.register-login__register-list {
  .ds1-mv-0();
  .ds1-utd-size-2();
}

.register-login__options-list {
  .ds1-mb-3();

  li {
    .ds1-mb-1();
  }
  
  p {
    .ds1-utd-size-3();
  }
}

#registerButton, #mergeButton {
  width: 150px;
}
</style>